import React from 'react';

const ANALYSIS_SECTIONS = [
  {
    key: 'ssl',
    icon: '🔒',
    title: 'Certificado SSL/TLS',
    bgColor: 'rgba(16, 185, 129, 0.1)',
    checksKey: 'ssl',
  },
  {
    key: 'domain',
    icon: '🌐',
    title: 'Análise de Domínio',
    bgColor: 'rgba(59, 130, 246, 0.1)',
    checksKey: 'domain',
  },
  {
    key: 'url',
    icon: '🔗',
    title: 'Estrutura da URL',
    bgColor: 'rgba(139, 92, 246, 0.1)',
    checksKey: 'url',
  },
  {
    key: 'security',
    icon: '🛡️',
    title: 'Verificações de Segurança',
    bgColor: 'rgba(6, 182, 212, 0.1)',
    checksKey: 'security',
  },
  {
    key: 'reputation',
    icon: '⭐',
    title: 'Reputação & Blacklists',
    bgColor: 'rgba(245, 158, 11, 0.1)',
    checksKey: 'reputation',
  },
  {
    key: 'content',
    icon: '📄',
    title: 'Análise de Conteúdo',
    bgColor: 'rgba(236, 72, 153, 0.1)',
    checksKey: 'content',
  },
];

const STATUS_ICONS = {
  pass: '✓',
  fail: '✗',
  warn: '!',
  info: 'i',
};

export default function AnalysisGrid({ checks }) {
  if (!checks) return null;

  return (
    <div className="analysis-grid">
      {ANALYSIS_SECTIONS.map((section) => {
        const sectionChecks = checks[section.checksKey];
        if (!sectionChecks || sectionChecks.length === 0) return null;

        return (
          <div key={section.key} className="analysis-card">
            <div className="analysis-card-header">
              <div
                className="analysis-card-icon"
                style={{ background: section.bgColor }}
              >
                {section.icon}
              </div>
              <div className="analysis-card-title">{section.title}</div>
            </div>
            <ul className="check-list">
              {sectionChecks.map((check, i) => (
                <li key={i} className="check-item">
                  <span className={`check-status ${check.status}`}>
                    {STATUS_ICONS[check.status]}
                  </span>
                  <span className="check-label">{check.label}</span>
                  {check.value && (
                    <span className="check-value">{check.value}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
